<!-- Statistic.vue -->
<template>
  <div class="custom-statistic" :class="size" :style="{ textAlign: align }">
    <div v-if="title || $slots.title" class="statistic-title">
      <slot name="title">{{ title }}</slot>
    </div>
    
    <div class="statistic-content">
      <span v-if="prefix || $slots.prefix" class="prefix">
        <slot name="prefix">{{ prefix }}</slot>
      </span>
      
      <span class="value" :style="valueStyle">
        {{ formattedValue }}
      </span>
      
      <span v-if="suffix || $slots.suffix" class="suffix">
        <slot name="suffix">{{ suffix }}</slot>
      </span>
    </div>
    
    <div v-if="$slots.extra" class="statistic-extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomStatistic',
  props: {
    title: String,
    value: [Number, String],
    precision: {
      type: Number,
      default: 0
    },
    prefix: String,
    suffix: String,
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['small', 'default', 'large'].includes(value)
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) => ['left', 'center', 'right'].includes(value)
    },
    valueStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedValue() {
      if (typeof this.value === 'number') {
        return this.value.toFixed(this.precision).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return this.value;
    }
  }
}
</script>

<style scoped>
.custom-statistic {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
}

.statistic-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 4px;
}

.statistic-content {
  line-height: 1;
}

.prefix, .suffix {
  font-size: 16px;
  margin: 0 2px;
}

.value {
  font-size: 24px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.statistic-extra {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

/* 尺寸 */
.custom-statistic.small .value {
  font-size: 20px;
}

.custom-statistic.large .value {
  font-size: 32px;
}

.custom-statistic.small .prefix,
.custom-statistic.small .suffix {
  font-size: 14px;
}

.custom-statistic.large .prefix,
.custom-statistic.large .suffix {
  font-size: 20px;
}
</style>